export default __webpack_public_path__ + "static/media/overtimeRules.10ba8c6b.png";